import { useState, useEffect } from 'react';
import ScrapedProductsPage from './ScrapedProductsPage';
import LionjobPage from './LionjobPage';

// 1 mục "Lionjob" duy nhất trên sidebar; bên trong có 2 tab: Scraped Products (kho) và Listing Task (làm SEO).
export default function LionjobHub() {
  const [tab, setTab] = useState(() => localStorage.getItem('lionjob_tab') || 'listing');
  useEffect(() => { localStorage.setItem('lionjob_tab', tab); }, [tab]);

  return (
    <div>
      <style>{TAB_CSS}</style>
      <div className="lj-tabs">
        <button className={'lj-tab' + (tab === 'products' ? ' active' : '')} onClick={() => setTab('products')}>🌐 Scraped Products</button>
        <button className={'lj-tab' + (tab === 'listing' ? ' active' : '')} onClick={() => setTab('listing')}>🐾 Listing Task</button>
      </div>
      {tab === 'products'
        ? <ScrapedProductsPage onOpenListing={() => setTab('listing')} />
        : <LionjobPage />}
    </div>
  );
}

const TAB_CSS = `
.lj-tabs{display:inline-flex;gap:0;border:1px solid var(--border);border-radius:12px;overflow:hidden;background:var(--panel);margin-bottom:16px}
.lj-tab{border:0;background:transparent;color:var(--muted);padding:8px 16px;font-size:13px;font-weight:600;cursor:pointer}
.lj-tab+.lj-tab{border-left:1px solid var(--border)}
.lj-tab:hover{color:var(--text)}
.lj-tab.active{background:var(--accent);color:#fff}
`;
